// This assumes that the format is in subdomain.domain.tld or domain.tld
// and that tld does not have multiple periods.
// This would break for things like curology.co.uk
export const getDomainFromHostname = (hostname: string) => {
  const hostnameArray = hostname.split('.');
  return hostnameArray.slice(hostnameArray.length - 2).join('.');
};
